import { render, staticRenderFns } from "./ListBroadcastMessage.vue?vue&type=template&id=177cf00e&scoped=true"
import script from "./ListBroadcastMessage.vue?vue&type=script&lang=js"
export * from "./ListBroadcastMessage.vue?vue&type=script&lang=js"
import style0 from "./ListBroadcastMessage.vue?vue&type=style&index=0&id=177cf00e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177cf00e",
  null
  
)

export default component.exports